import React, { useState } from "react";

const TABS = [
  { key: "all", label: "All Time" },
  { key: "today", label: "Today" },
  { key: "week", label: "Week" },
  { key: "mtd", label: "Month to Date" },
  { key: "custom", label: "Date Range" },
];

export default function TimeTabs({ value, onChange }) {
  const { period = "all", frm = "", to = "" } = value || {};
  const [showRange, setShowRange] = useState(period === "custom");

  const pick = (k) => {
    if (k === "custom") { setShowRange(true); onChange({ period: "custom", frm, to }); }
    else { setShowRange(false); onChange({ period: k, frm: "", to: "" }); }
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="time-tabs">
      <div className="inline-flex rounded-lg border border-gray-200 bg-white p-0.5">
        {TABS.map((t) => (
          <button key={t.key} data-testid={`time-tab-${t.key}`} onClick={() => pick(t.key)}
            className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-colors ${period === t.key ? "bg-[#8B0000] text-white" : "text-gray-600 hover:text-[#8B0000]"}`}>
            {t.label}
          </button>
        ))}
      </div>
      {showRange && (
        <div className="flex items-center gap-1.5">
          <input data-testid="time-from" type="date" value={frm} onChange={(e) => onChange({ period: "custom", frm: e.target.value, to })}
            className="border border-gray-300 rounded-lg px-2 py-1.5 text-sm outline-none focus:border-[#8B0000]" />
          <span className="text-gray-400 text-sm">→</span>
          <input data-testid="time-to" type="date" value={to} onChange={(e) => onChange({ period: "custom", frm, to: e.target.value })}
            className="border border-gray-300 rounded-lg px-2 py-1.5 text-sm outline-none focus:border-[#8B0000]" />
        </div>
      )}
    </div>
  );
}
